import { Button, CircularProgress, Stack } from "@mui/material";
import { CustomTextField } from "../../../component/CustomTextField";
import { CustomTextView } from "../../../component/CustomTextView";
import { ChangePasswordViewModel } from "./ChangePasswordViewModel";
import { provideChangePasswordUseCase } from "../../../di/UseCasesModule";
import { CustomButtonView } from "../../../component/CustomButtonView";

interface props {
  handleClosePopover: () => void;
}

export function ChangePasswordView(props: props) {
  const viewModel = ChangePasswordViewModel(provideChangePasswordUseCase());

  return (
    <Stack spacing={2} p={2} minWidth={"30vmax"}>
      <CustomTextField
        type="password"
        placeholder="Password"
        onTextChange={(password) => {
          viewModel.setPassword(password);
        }}
      />
      <CustomTextField
        type="password"
        placeholder="Confirm"
        onTextChange={(password) => {
          viewModel.setConfirmPassword(password);
        }}
      />
      <CustomButtonView
        text="Change"
        loading={viewModel.isLoading}
        buttonProps={{ pt: 2, pb: 2 }}
        onClick={() => viewModel.changePassword(props.handleClosePopover)}
      />
    </Stack>
  );
}
